import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import ButtonOutline from 'UiKit/button/buttonOutline';
import { TextSemiBold } from 'UiKit/typography';

import { useReportAttendanceHostDetailState } from 'View/report-attendance-host-detail/state';

import styles from './styles.module.css';

const ColumnLivestream = ({ values }) => {
  const { t } = useTranslation('report-attendance-host-detail');
  const { updateState } = useReportAttendanceHostDetailState();

  return (
    <Box className={styles['column-livestream__container']}>
      <ButtonOutline
        width="103px"
        height="28px"
        onClick={() =>
          updateState({
            isOpenModalDetailLivestream: true,
            livestreamData: values,
          })
        }
      >
        <TextSemiBold fontSize="var(--font-body3)" color="var(--color-primary70)">
          {t('tableColumn.viewLivestreamDetail')}
        </TextSemiBold>
      </ButtonOutline>
    </Box>
  );
};

export default ColumnLivestream;
